/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimImageDTO } from './ClaimImageDTO';
export type ClaimInvoiceDTO = {
    id?: string;
    invoiceNo?: string;
    amount?: number;
    paymentType?: ClaimInvoiceDTO.paymentType;
    paymentMethod?: ClaimInvoiceDTO.paymentMethod;
    createdBy?: string;
    createdByFirstName?: string;
    createdByLastName?: string;
    status?: ClaimInvoiceDTO.status;
    remark?: string;
    paidAt?: string;
    createdAt?: string;
    slips?: Array<ClaimImageDTO>;
    paymentChannelType?: ClaimInvoiceDTO.paymentChannelType;
    bankCode?: ClaimInvoiceDTO.bankCode;
    accountName?: string;
    accountId?: string;
};
export namespace ClaimInvoiceDTO {
    export enum paymentType {
        NONE = 'NONE',
        DEPOSIT = 'DEPOSIT',
        DEPOSIT_REFUND = 'DEPOSIT_REFUND',
        INSTALLMENT = 'INSTALLMENT',
        FULL_PAYMENT = 'FULL_PAYMENT',
        COMPENSATION = 'COMPENSATION',
        REFUND_COMPENSATION = 'REFUND_COMPENSATION',
        HIRE = 'HIRE',
    }
    export enum paymentMethod {
        NONE = 'NONE',
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        BANK_TRANSFER = 'BANK_TRANSFER',
    }
    export enum status {
        SUCCESS = 'SUCCESS',
        CANCEL = 'CANCEL',
    }
    export enum paymentChannelType {
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        PROMPT_PAY_QR = 'PROMPT_PAY_QR',
        BANK_ACCOUNT = 'BANK_ACCOUNT',
        AUTOMATIC_QR = 'AUTOMATIC_QR',
        TRUE_WALLET = 'TRUE_WALLET',
        CHILLPAY_QR = 'CHILLPAY_QR',
    }
    export enum bankCode {
        BBL = 'BBL',
        BAY = 'BAY',
        SCB = 'SCB',
        KBANK = 'KBANK',
        KTB = 'KTB',
        TTB = 'TTB',
    }
}

